import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Preferences = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M8.71 5.08V6.5H7.29V5.08h1.42Zm.15-1.4H7.14c-.69 0-1.25.56-1.25 1.25v.06H3.54c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h2.35v.06c0 .69.56 1.25 1.25 1.25h1.72c.69 0 1.25-.56 1.25-1.25V4.93c0-.69-.56-1.25-1.25-1.25ZM20.46 4.99h-9.39v1.6h9.39c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8ZM8.71 17.5v1.42H7.29V17.5h1.42Zm.15-1.4H7.14c-.69 0-1.25.56-1.25 1.25v.06H3.54c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h2.35v.06c0 .69.56 1.25 1.25 1.25h1.72c.69 0 1.25-.56 1.25-1.25v-1.72c0-.69-.56-1.25-1.25-1.25ZM20.46 17.41h-9.39v1.6h9.39c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8ZM12.96 11.2H3.54c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h9.42v-1.6ZM16.71 11.29v1.42h-1.4v-1.42h1.4Zm.15-1.4h-1.72c-.64 0-1.15.49-1.22 1.12V13c.07.62.58 1.12 1.22 1.12h1.72c.69 0 1.25-.56 1.25-1.25v-.06h2.35c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8h-2.35v-.06c0-.69-.56-1.25-1.25-1.25v-.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Preferences
